
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "@/components/ui/link";

interface ConsentSectionProps {
  hasConsent: boolean;
  hasDataConsent: boolean;
  onConsentChange: (checked: boolean) => void;
  onDataConsentChange: (checked: boolean) => void;
}

export const ConsentSection = ({
  hasConsent,
  hasDataConsent,
  onConsentChange,
  onDataConsentChange,
}: ConsentSectionProps) => {
  return (
    <div className="space-y-4 mb-6">
      <h3 className="text-lg font-medium">Samtycke till att delta i studien</h3>
      <p>
        Jag har fått muntlig och skriftlig informationen om studien och har haft möjlighet att ställa
        frågor.{" "}
        <Link href="/FPI_gruppled.pdf" target="_blank" className="text-primary hover:underline">
          Skriftlig information finns här
        </Link>
      </p>
      <p>Jag får behålla den skriftliga informationen.</p>
      <div className="space-y-4">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="consent" 
            checked={hasConsent}
            onCheckedChange={(checked) => onConsentChange(checked as boolean)}
          />
          <label htmlFor="consent">
            Jag samtycker till att delta i studien: Effekter av "Föräldraskap i Sverige på förtroendet
            för Socialtjänsten".
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="dataConsent" 
            checked={hasDataConsent}
            onCheckedChange={(checked) => onDataConsentChange(checked as boolean)}
          />
          <label htmlFor="dataConsent">
            Jag samtycker till att uppgifter om mig behandlas på det sätt som beskrivs i
            forskningspersonsinformationen.
          </label>
        </div>
      </div>
    </div>
  );
};
